import { log } from '../logger';
import * as LogEvents from './logging';

export * from './events';
export * from './gtm';
export * from './logging';

export const AnalyticsService = Object.fromEntries(
  Object.entries(LogEvents).map(([key, value]) => [
    key,
    value instanceof Function
      ? (...args: any[]) => {
          try {
            // @ts-expect-error -- Catch dynamic error from function call
            return value(...args);
          } catch (e) {
            log(new Error(`Error in analytics event '${key}'`), e);
          }
        }
      : value,
  ]),
) as typeof LogEvents;
